import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm, ValidatorFn, EmailValidator, Validators } from '@angular/forms';
import { LoadJsService } from '../../load-js/load-js.service';
import { URLSearchParams } from '@angular/http';
import swal from 'sweetalert/dist/sweetalert.min.js';

@Component({
  selector: 'app-runningtext',
  templateUrl: './runningtext.component.html',
  styleUrls: ['./playbox.component.css']
})
export class RunningtextComponent implements OnInit {
  @ViewChild('closeBtn', { static: false }) closeBtn: ElementRef;

  textSearch = new FormControl('');
  
  msearch : string;
  customercategory:string;
  custcat:string;
  runningtexttype:string;
  limit = 10;

  //pagination
  paging_link : any = [];
  paging : any = {};
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  //end pagination

  formSet = this.fb.group({
    runningtexttype: [''],
    customerid: [''],
    customercategoryid: [''],
    title: [''],
    description: [''],
    img: [''],
    publishdate: [''],
  })

  listrunningtext:any = []
  listcust:any = []
  listcustdata:any = []
  listcustcategory:any = []
  runningtextdetail:any = []
  listrunningtexttype:any = []
  alert_act: any = []
  alert_act2: any = []
  showntypex: any = []
  itemset: any = {}
  custidadd: any = {}

  table_load = true

  message : string
  custname : string
  lengthcust : number
  confirmation = false
  custidvalue = false
  custidinput = false


  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public LoadJs: LoadJsService,
    private router: Router
  ) { }

  ngOnInit() {
    this.loadStart()
  }
  
  loadStart() {
    
    this.route.queryParams
      .subscribe(params => {

        //this.order = params.order;
        //console.log(this.order); // popular

        if ((params.search != '' || params.customercategory != ''  || params.runningtexttype != '') && params.search != undefined ){
          // console.log('search');
          // console.log(params.search);
          this.msearch = params.search 
          this.customercategory = params.customercategory;
          this.runningtexttype = params.runningtexttype;
          this.querySearch = true
        

          this.currentParams = params;
          this.queryParams = '?'+this.queryStr(params)
          this.loadList(this.queryParams)
        
        }else{
          this.querySearch = false;
          this.currentParams = params

          this.queryParams = '?'+this.queryStr(params)
          this.loadList(this.queryParams)
        }
      });

      this.clearForm()
      this.loadcustcategory()
      this.loadtype()
      this.msearch = undefined
      this.customercategory = undefined
      this.runningtexttype = undefined
    
  }
  
  refreshPage() {
    this.ngOnInit()
  }

  search()
  {
    this.querySearch = true

    if ( this.msearch == undefined){
      this.msearch = ''
    }
    // if ( this.runningtexttype == undefined ){
    //   this.runningtexttype =  'All'
    // }
    if ( this.limit != undefined ){
      this.searchQueryParams += '&limit='+this.limit
    }

    if ( this.customercategory == undefined ){
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch+'&customercategory=All'+'&runningtexttype='+this.runningtexttype
    }else{
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch+'&customercategory='+this.customercategory+'&runningtexttype='+this.runningtexttype
    }
    
    this.loadList(this.searchQueryParams)
  }

  queryStr(options: any){
    let params = new URLSearchParams()
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString()
  }

  queryStrSearch()
  {
    if ( this.msearch ){
      return '&search='+this.msearch
    }else{
      return ''
    }
  }

  clearForm() {
    this.formSet.reset()
    this.custidvalue = false
    this.custidinput = false
    this.formSet.get('customercategoryid').setValue(undefined)
    this.formSet.get('runningtexttype').setValue(undefined)
    this.listcustdata = []
    this.custidadd = 100
  }

  onActionClick(act:any, item: any) {
    this.alert_act = act

    if(this.alert_act == 'add'){
      this.clearForm()
    }
    if(this.alert_act == 'view'){
      this.itemset = item
      this.loadrunningtextdetail(item.id)
    }
  }
  onChangebtn(act2:any, e: any) {
    this.alert_act2 = act2

    if(this.alert_act2 == 'rtxtype'){
      // console.log(e.target.value)
      if(e.target.value == 2){
        this.custidadd = 100
        this.custidvalue = true
        this.custidinput = true
        this.formSet.get('customerid').setValue(null)
        this.formSet.get('customercategoryid').setValue(undefined)

      }else{
        this.custidadd = {}
        this.listcustdata = []
        this.custidvalue = false
        this.custidinput = false
        this.formSet.get('customerid').setValue('All')
        this.formSet.get('customercategoryid').setValue(undefined)

      }
    }
  }
  onLength(){
    this.listcustdata = []
    this.custidadd = 100
    let item = this.formSet.get('customerid').value
    if(item.length >= 4){
      this.loadlistcust(item)
      this.lengthcust = 4 - item.length
      this.custidinput = true
      // console.log(this.lengthcust, item.length)
    }else{
      this.lengthcust = 4 - item.length
      this.custidinput = false
      // console.log(this.lengthcust, item.length)
    }
  }
  pushcust(){

    // console.log(this.custidadd)
    this.formSet.get('customerid').setValue(this.custidadd.id)
    this.formSet.get('customercategoryid').setValue(this.custidadd.customercategoryid)
  }

  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }
  alertsx(message:any){
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
    });
    setTimeout(()=>{
      this.closeModal()
      this.ngOnInit()
    }, 1000);
  }
  alertfx(message:any){
    swal({
      title: "Gagal!",
      text: message,
      icon: "error",
    });
    
  }

  loadlistcust(item:any){
    let data = { "search": item }
    return this.partnerService.Listcustomerplaybox(data).subscribe((output: any) => {
      // console.log(output)
        this.listcust = output.data

        this.listcust.forEach((row:any) => {
          this.listcustdata.push(row)
        })
        
    })
  }

  loadList(params: any) {
    this.table_load = true

    return this.partnerService.Getlistrunningtext(params).subscribe((output: any) => {
    // console.log(output)
      this.listrunningtext = output.data

      this.table_load = false

      this.paging = output.pagex;
      this.page_self = output.pagex.self
      this.page_next = output.pagex.next
      this.page_prev = output.pagex.prev
      this.meta = output.meta
      this.total_count = this.meta['totalCount']
      let self = this.page_self['page']
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage'])
      }else{
        this.last_index = this.meta['totalCount']
      }
      this.first_index = ((self-1)*this.meta['perPage'])+1

    })
  }

  loadrunningtextdetail(id:any){
    this.partnerService.Getrunningtextdetail(id).subscribe((output: any) => { 
      this.runningtextdetail = output.data

      this.formSet.get('runningtexttype').setValue(this.runningtextdetail.runningtexttype)
      this.formSet.get('customerid').setValue(this.runningtextdetail.customerid)
      this.formSet.get('customercategoryid').setValue(this.runningtextdetail.customercategoryid)
      this.formSet.get('title').setValue(this.runningtextdetail.title)
      this.formSet.get('description').setValue(this.runningtextdetail.description)
      this.formSet.get('img').setValue(this.runningtextdetail.img)
      this.formSet.get('publishdate').setValue(this.runningtextdetail.publishdate)
      this.custname = this.runningtextdetail.customername

    }); 
  }
  
  loadcustcategory() {
    this.partnerService.Getcustcategory().subscribe((output: any) => { 
      this.listcustcategory = output.data
    });  
  }
  loadtype() {
    this.partnerService.Getrunningtexttype().subscribe((output: any) => { 
      this.listrunningtexttype = output.data
    })
  }

  submitAdd() {
    if(this.formSet.value.customercategoryid == undefined){
      this.formSet.get('customercategoryid').setValue(100)
    }

    // console.log(this.formSet.value)
    
    this.partnerService.Addrunningtext(this.formSet.value)
      .subscribe((output: any) => { 
        if(output){
          if (output.status == true) {
            
            this.message = output.message
            this.alertsx(this.message)
            
          } else {
            this.message = output.message
            this.alertfx(this.message)
          }
        }else{
          this.alertfx("Error hit API")
        }
    })
  }
  submitSet() {
    let id = this.itemset.id
    // console.log(id, this.formSet.value)
    
    this.partnerService.Setrunningtext(id, this.formSet.value)
      .subscribe((output: any) => { 
        if (output.status == true) {

          this.message = output.message
          this.alertsx(this.message)

        } else {

          this.message = output.message
          this.alertfx(this.message)

        }
    })
  }
  submitDelete() {
    let id = this.itemset.id

    swal({
      title: "Are you sure?",
      text: '"'+this.itemset.title+'" Akan dihapus',
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        // console.log(id,this.itemset)
        this.partnerService.Deleterunningtext(id)
          .subscribe((output: any) => { 
            if (output.status == true) {

              this.message = output.message
              this.alertsx(this.message)

            } else {

              this.message = output.message
              this.alertfx(this.message)

            }
        })
        
      } 
      // else {
      //   swal('"'+this.itemset.title+'" Batal dihapus');
      // }
    });
    
  }

}

